import React from "react";
import { Box } from "@mui/material";
import { JobDescription } from "./JobDescription/JobDescription";
import rthgLogo from "../../assets/logos/rthg.png";
import arkLogo from "../../assets/logos/ark.png";
import discoLogo from "../../assets/logos/disco.jpg";
import { RthgJobContent } from "./RthgJobContent";
import { DiscoJobContent } from "./DiscoJobContent";
import { ArkJobContent } from "./ArkJobContent";
import { PaperJobContent } from "./PaperJobContent";

type JobItem = {
  logo?: string;
  color: string;
  companyName: string;
  jobDetails: string;
  companyUrl: string;
  Child: () => React.ReactElement;
};

const jobs: JobItem[] = [
  {
    logo: rthgLogo,
    color: "#0F334C",
    companyName: "Road to Health Group",
    jobDetails:
      "Road to Health Group is a digital wellbeing company working with insurers, employers and schools to help people improve their health in practical, measurable ways through evidence-based programs",
    companyUrl: "https://roadtohealthgroup.com/",
    Child: RthgJobContent,
  },
  {
    logo: discoLogo,
    color: "#181F00",
    companyName: "Its Disco",
    jobDetails:
      "Disco is a social music discovery platform built around people not algorithms, helping friends share music, build playlists together, and discover new sounds through their community.",
    companyUrl: "https://itsdisco.com/",
    Child: DiscoJobContent,
  },
  {
    logo: arkLogo,
    color: "#383535",
    companyName: "Project Ark",
    jobDetails:
      "A community management platform that connects property managers, residents, and on-site teams, streamlining communication, payments, and daily operations.",
    companyUrl: "https://communities.projectark.co.uk/",
    Child: ArkJobContent,
  },
  {
    color: "#383535",
    companyName: "Small or Far Away?",
    jobDetails:
      "Coauthored paper on applying deep learning techniques for wildlife detection published at WACV 2022.",
    companyUrl: "https://arxiv.org/abs/2111.06830",
    Child: PaperJobContent,
  },
];

export default function Work() {
  return (
    <Box
      sx={{
        boxShadow: "0 -20px 40px rgba(0, 0, 0, 0.2)",
        pt: { xs: 8, sm: 12, md: 24 },
        pb: { xs: 4, md: 12 },
      }}
    >
      <Box>
        <Box
          display="grid"
          gap={{ xs: 3, md: 4 }}
          sx={{
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(2, 1fr)",
              lg: "repeat(3, 1fr)",
            },
            pt: { xs: 8, md: 0 },
            px: { xs: 3, sm: 4, md: 12 },
          }}
        >
          {jobs.map(({ Child, ...props }) => (
            <JobDescription key={props.companyName} {...props}>
              <Child />
            </JobDescription>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
